export type Point = {
  x: number;
  y: number;
};

export const distanceBetween = (pointA: Point, pointB: Point) => {
  const dx = pointA.x - pointB.x;
  const dy = pointA.y - pointB.y;
  return Math.sqrt(dx * dx + dy * dy);
};

export const demoOneLevels = [
  {
    id: 'A',
    label: 'Levels A',
    start: {
      x: 1 / 2,
      y: 1 / 6,
    },
    levels: [
      {
        label: 'L',
        value: 100,
      },
      {
        label: 'R',
        value: 0,
      },
    ],
  },
  {
    id: 'B',
    label: 'Levels B',
    start: {
      x: 1 / 2,
      y: 5 / 6,
    },
    levels: [
      {
        label: 'L',
        value: 0,
      },
      {
        label: 'R',
        value: 100,
      },
    ],
  },
];

export const demoTwoLevels = [
  {
    id: 'A',
    label: 'Levels A',
    start: {
      x: 0.3705035971,
      y: 0.74,
    },
    levels: [
      {
        label: 'L',
        value: 100,
      },
      {
        label: 'R',
        value: 0,
      },
    ],
  },
  {
    id: 'B',
    label: 'Levels B',
    start: {
      x: 0.3705035971,
      y: 0.2355289421,
    },
    levels: [
      {
        label: 'L',
        value: 0,
      },
      {
        label: 'R',
        value: 100,
      },
    ],
  },
];
